import { render } from "./IPInfoDetector.vue?vue&type=template&id=4b3d1cf2&scoped=true"
import script from "./IPInfoDetector.vue?vue&type=script&lang=js"
export * from "./IPInfoDetector.vue?vue&type=script&lang=js"

import "./IPInfoDetector.vue?vue&type=style&index=0&id=4b3d1cf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3d1cf2"]])

export default __exports__